import React from "react";

export const Footer = () => {
  return (
    <footer className="relative border-t border-white/5 pt-24 pb-10" data-testid="site-footer">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-brand/60 to-transparent" />
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="font-display font-black tracking-[0.15em] text-brand text-2xl">BGS</div>
            <div className="mt-1 uppercase tracking-[0.35em] text-brand/80 font-semibold text-xs">Grading Services</div>
            <p className="mt-6 text-white/50 text-sm max-w-sm leading-relaxed">
              AI-powered sports card grading. Deterministic accuracy. Zero human error. Built for a collector-first
              future.
            </p>
          </div>

          <div className="md:col-span-2">
            <div className="text-[10px] uppercase tracking-[0.3em] text-brand font-bold mb-4">Company</div>
            <ul className="space-y-3 text-white/60 text-sm">
              <li><a href="#how" className="hover:text-white">How it Works</a></li>
              <li><a href="#tiers" className="hover:text-white">Tiers</a></li>
              <li><a href="#faq" className="hover:text-white">FAQ</a></li>
              <li><a href="#submit" className="hover:text-white">Submit</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-[10px] uppercase tracking-[0.3em] text-brand font-bold mb-4">Legal</div>
            <ul className="space-y-3 text-white/60 text-sm">
              <li><a href="#" className="hover:text-white">Terms</a></li>
              <li><a href="#" className="hover:text-white">Privacy</a></li>
              <li><a href="#" className="hover:text-white">Grading Rubric</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.3em] text-brand font-bold mb-4">Contact</div>
            <ul className="space-y-3 text-white/60 text-sm">
              <li>Mon–Fri · 9am–6pm ET</li>
            </ul>
          </div>
        </div>

        {/* bottom line */}
        <div className="mt-20 flex flex-col md:flex-row items-center justify-between gap-3 pt-6 border-t border-white/5 text-xs text-white/40">
          <div>© {new Date().getFullYear()} Blue Grading Services. All rights reserved.</div>
          <div className="font-mono uppercase tracking-[0.25em]">BGS · AI Precision Grading</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
